module.exports = __webpack_public_path__ + "static/media/IconFolderInactive.3dd06098.svg";